import { Center } from "@/common/css";
import Icon from "@/common/ui/Image";
import { LightText, LightText2 } from "@/common/ui/Text";
import React, { PropsWithChildren } from "react";

interface EmptyListProps extends PropsWithChildren {
  text: string;
  description?: string;
  icon: string;
  className?: string;
  textClassName?: string;
}

const EmptyList: React.FC<EmptyListProps> = ({ text, description, icon, children, className, textClassName = "" }) => {
  return (
    <Center className={`flex-col ${className}`}>
      <Icon alt="icon" src={icon} />
      <LightText text={text} className={` !text-black ${textClassName} `} />
      {description && <LightText2 text={description} className="text-center" />}
      {children}
    </Center>
  );
};

export default EmptyList;
